var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{staticStyle:{"background-color":"#FFFFFF"},attrs:{"width":"200px"}},[_c('Manage')],1),_c('el-container',[_c('el-header',{staticStyle:{"height":"50px","padding":"0"}}),_c('el-main',{staticStyle:{"padding":"0","overflow-y":"hidden"}},[_c('createContent')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }